export const UMB_MEDIA_TYPE_FOLDER_REPOSITORY_ALIAS = 'Umb.Repository.MediaType.Folder';
export const UMB_MEDIA_TYPE_FOLDER_STORE_ALIAS = 'Umb.Store.MediaType.Folder';
export * from './media-type-folder.repository.js';
export { UMB_MEDIA_TYPE_FOLDER_STORE_CONTEXT } from './media-type-folder.store.context-token.js';
